import { Grid2 as Grid } from "@mui/material";
import { ReactComponent as XCloseIcon } from "components/Icons/x-close.svg";
import { useMessage } from "hooks/intl";
import { SelectedFilter } from "types/filters";
import { Conditions } from "../FilterBase/Conditions";
import { Values } from "../FilterBase/Values";
import { useStyles } from "../styles";

interface Props {
  filter: SelectedFilter;
  setFieldValue: (field: string, value: any) => void;
  index: number;
  handleSubmit: (e?: React.FormEvent<HTMLFormElement>) => void;
  clearFilter: () => void;
  setIsEditingFilters: (val: boolean) => void;
}

export const InlineFilter = ({
  filter,
  setFieldValue,
  index,
  handleSubmit,
  clearFilter,
  setIsEditingFilters,
}: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <div className={classes.singleFilter}>
      <Grid className={classes.filterLabel}>
        <Grid size={{ xs: 3 }}>{message({ id: filter.label })}:</Grid>
        <Grid size={{ xs: 3 }}>
          <Conditions
            filter={filter}
            index={index}
            size="inline"
            onChange={() => handleSubmit()}
          />
        </Grid>
        <Grid size={{ xs: 3 }}>
          <Values
            filter={filter}
            setFieldValue={setFieldValue}
            index={index}
            size="inline"
            onChange={() => handleSubmit()}
            setIsEditingFilters={setIsEditingFilters}
          />
        </Grid>
      </Grid>
      <XCloseIcon
        className={classes.clearIcon}
        onClick={clearFilter}
        data-test-id="remove-filter-button"
      />
    </div>
  );
};
